import { io } from 'socket.io-client';
import configApi from '@/api/config';
import store from '@/store/store';
import enums from '@/enums';
import { v4 as uuidv4 } from 'uuid';

let $socket = null;
let listeners = [];

function logListeners(eventName) {
  console.log('All listeners: ', listeners);

  if (listeners && Array.isArray(listeners) && $socket) {
    console.log(
      `Listeners by ${eventName}`,
      listeners.filter((l) => l.event === eventName),
      $socket.listeners(eventName),
    );
  }
}

export function connectSocket() {
  if (!store.getters['auth/isUserLoggedIn']) {
    return null;
  }

  if ($socket) {
    return $socket;
  }

  const apiUrl = new URL(configApi.url);
  const baseApiUrl = apiUrl.origin;

  $socket = io(baseApiUrl, {
    path: process.env.VUE_APP_ENV === enums.AppEnvironments.PRODUCTION
    || process.env.VUE_APP_ENV === enums.AppEnvironments.STAGING
      ? '/api/socket.io/' : '',
    query: {
      tenant: store.getters['auth/tenantId'],
      user: store.getters['auth/userId'],
    },
  });

  console.log('socket connected', baseApiUrl, $socket);

  return $socket;
}

export function getSocket() {
  return connectSocket();
}

export function registerSocketEvent(
  eventName,
  callback,
  listenerID = uuidv4(),
  avoidRepeated = false,
) {
  connectSocket();
  let result = false;

  if (!Array.isArray(listeners)) {
    listeners = [];
  }

  const listenerIndex = listeners.findIndex((listener) => listener.id === listenerID);

  if ($socket && (listenerIndex === -1 || !avoidRepeated)) {
    const cb = (payload) => {
      console.log(`Listen ${eventName} with payload`, payload);
      callback(payload);
    };

    $socket.on(eventName, cb);
    listeners.push({
      event: eventName,
      id: listenerID,
      cb,
    });
    console.log(`socket event '${eventName}' with id '${listenerID}' registered`);
    result = true;
  } else {
    console.log(`socket event '${eventName}' with id '${listenerID}' not registered`);
  }

  logListeners(eventName);
  return result;
}

export function unregisterSocketEvent(
  eventName,
  listenerID,
) {
  let result = false;

  if (!listeners || !Array.isArray(listeners)) {
    console.log(`socket event '${eventName}' with id '${listenerID}' not unregistered - listeners is null/undefined`);
    return false;
  }

  const listenerIndex = listeners.findIndex((listener) => listener.id === listenerID);

  if ($socket && listenerIndex !== -1) {
    try {
      $socket.off(eventName, listeners[listenerIndex].cb);
      listeners.splice(listenerIndex, 1);
      console.log(`socket event '${eventName}' with id '${listenerID}' unregistered`);
      result = true;
    } catch (error) {
      console.error(`Error unregistering socket event '${eventName}' with id '${listenerID}':`, error);

      if (listenerIndex !== -1) {
        listeners.splice(listenerIndex, 1);
      }
    }
  } else {
    console.log(`socket event '${eventName}' with id '${listenerID}' not unregistered - socket:${!!$socket}, listenerIndex:${listenerIndex}`);
  }

  logListeners(eventName);
  return result;
}

export function removeSocket() {
  if ($socket) {
    try {
      if (Array.isArray(listeners)) {
        listeners.forEach((listener) => {
          try {
            $socket.off(listener.event, listener.cb);
          } catch (error) {
            console.error('Error removing individual listener:', error);
          }
        });
      }

      $socket.removeAllListeners();
      $socket.close();
    } catch (error) {
      console.error('Error removing socket:', error);
    } finally {
      listeners = [];
      $socket = null;
    }
  }
}

store.subscribe((mutation, { auth }) => {
  switch (mutation.type) {
    case 'auth/SET_AUTH_USER_IS_LOGGED_IN':
      if (auth.isUserLoggedIn) {
        connectSocket();
      } else {
        removeSocket();
      }
      break;

    case 'auth/DELETE_AUTH':
      removeSocket();
      break;
    default:
  }
});
